import { StateProvider } from '@uirouter/angularjs'
import angular from 'angular'

import { ROUTES, STATES } from '../../../lib/routes'

/**
 * =======================================
 * ROUTES CONFIG - CASH MANAGEMENT
 * =======================================
 *
 * @module webregister.routes.cash-manangement
 */
function CashManagementRoutesConfig($stateProvider: StateProvider) {
  $stateProvider.state(STATES.CASH_MANAGEMENT, {
    url: ROUTES.CASH_MANAGEMENT,
    template: '<cash-management-view></cash-management-view>',
  })
}

angular.module('webregister.routes').config(CashManagementRoutesConfig)
